import { EChartsCoreOption } from 'echarts';
import React from 'react'
import ChartComponent from 'src/helpers/Echarts/ChartComponent';
import { OverallImpactProps } from './modules';

// type Props = OverallImpactProps & { series: any }

const OverallImpactDashboard = ({ percentage, trend, description, series }: OverallImpactProps) => {
    const options: EChartsCoreOption = React.useMemo(
        () => ({
            tooltip: {
                trigger: 'item',
            },
            legend: {
                show: false,
            },
            graphic: [
                {
                    type: 'text',
                    left: 'center',
                    top: '24%',
                    style: {
                        text: percentage,
                        fontSize: 24,
                        fontWeight: 'bold',
                        fill: '#333',
                    },
                },
                {
                    type: 'text',
                    left: 'center',
                    top: '32%',
                    style: {
                        text: trend,
                        fontSize: 16,
                        fontWeight: 'normal',
                        fill: '#333',
                    },
                },
                {
                    type: 'text',
                    left: 'center',
                    top: '40%',
                    style: {
                        text: description,
                        fontSize: 12,
                        fontWeight: 'normal',
                        fill: '#333',
                    },
                },
            ],
            label: {
                show: false,
            },
            labelLine: {
                show: false,
            },
            series: [
                {
                    name: 'Overall Impact',
                    type: 'pie',
                    top:-40,
                    radius: ['70%', '90%'],
                    startAngle: 180,
                    endAngle: 360,
                    data: series,
                },
            ],
        }),
        [percentage, trend, description, series]
    );

    return (
        <div className="relative h-[180px] bg-white rounded-lg shadow-sm border border-gray-300 p-2  ">
            <ChartComponent options={options} />
        </div>
    );
}

export default OverallImpactDashboard